<template>
  <section class="notifications-page">

    <!-- =====================================================
         HEADER CARD
    ====================================================== -->

    <div class="notifications-card">

      <div class="card-glow card-glow-blue"></div>
      <div class="card-glow card-glow-purple"></div>

      <div class="card-header">

        <div class="header-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M18 9C18 5.69 15.31 3 12 3C8.69 3 6 5.69 6 9V12.5C6 13.6 5.55 14.66 4.76 15.44L4 16.2C3.37 16.83 3.82 17.9 4.71 17.9H19.29C20.18 17.9 20.63 16.83 20 16.2L19.24 15.44C18.45 14.66 18 13.6 18 12.5V9Z"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linejoin="round"
            />

            <path
              d="M9.5 20C10.1 20.65 10.95 21 12 21C13.05 21 13.9 20.65 14.5 20"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
            />
          </svg>
        </div>

        <div class="header-copy">

          <div class="eyebrow">
            Настройки
          </div>

          <h2 class="card-title">
            Уведомления
          </h2>

          <p class="card-description">
            Выберите, как Hr3 будет сообщать вам о важных событиях,
            обновлениях и активности в вашем профиле.
          </p>

        </div>

      </div>

    </div>


    <!-- =====================================================
         SETTINGS
    ====================================================== -->

    <div class="settings-card">

      <div class="section-heading">

        <div class="section-eyebrow">
          Каналы уведомлений
        </div>

        <h3>
          Как с вами связываться
        </h3>

        <p>
          Эти настройки можно изменить в любой момент.
        </p>

      </div>


      <div class="settings-list">

        <!-- EMAIL -->

        <div class="notification-row">

          <div class="notification-icon email-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <rect
                x="3.5"
                y="5.5"
                width="17"
                height="13"
                rx="2.5"
                stroke="currentColor"
                stroke-width="1.7"
              />

              <path
                d="M5 8L12 13L19 8"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>


          <div class="notification-copy">

            <div class="notification-title-row">

              <div class="notification-title">
                Email-уведомления
              </div>

              <div
                class="status-badge"
                :class="{ active: notifications.buyer }"
              >
                <span class="status-dot"></span>

                {{
                  notifications.buyer
                    ? "Включено"
                    : "Выключено"
                }}
              </div>

            </div>


            <div class="notification-description">
              Получайте важные уведомления и обновления
              на вашу электронную почту.
            </div>

          </div>


          <button
            type="button"
            class="ios-switch"
            :class="{ active: notifications.buyer }"
            :aria-pressed="notifications.buyer"
            @click="notifications.buyer = !notifications.buyer"
          >
            <span class="switch-knob"></span>
          </button>

        </div>


        <div class="divider"></div>


        <!-- PUSH -->

        <div class="notification-row">

          <div class="notification-icon push-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <rect
                x="7"
                y="2.5"
                width="10"
                height="19"
                rx="2.5"
                stroke="currentColor"
                stroke-width="1.7"
              />

              <path
                d="M10.5 18.5H13.5"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
              />

              <circle
                cx="12"
                cy="9"
                r="2.5"
                stroke="currentColor"
                stroke-width="1.6"
              />
            </svg>
          </div>


          <div class="notification-copy">

            <div class="notification-title-row">

              <div class="notification-title">
                Push-уведомления
              </div>

              <div
                class="status-badge"
                :class="{ active: notifications.review }"
              >
                <span class="status-dot"></span>

                {{
                  notifications.review
                    ? "Включено"
                    : "Выключено"
                }}
              </div>

            </div>


            <div class="notification-description">
              Получайте уведомления о новых событиях,
              откликах и другой активности прямо на устройстве.
            </div>

          </div>


          <button
            type="button"
            class="ios-switch"
            :class="{ active: notifications.review }"
            :aria-pressed="notifications.review"
            @click="notifications.review = !notifications.review"
          >
            <span class="switch-knob"></span>
          </button>

        </div>

      </div>


      <!-- =====================================================
           SAVE
      ====================================================== -->

      <div class="save-area">

        <div class="save-state">

          <span
            class="save-state-dot"
            :class="{ changed: isChanged }"
          ></span>

          {{
            isChanged
              ? "Есть несохранённые изменения"
              : "Все изменения сохранены"
          }}

        </div>


        <button
          type="button"
          class="primary-btn"
          :class="{
            saved: justSaved
          }"
          :disabled="!isChanged || isSaving"
          @click="save"
        >
          <span
            v-if="isSaving"
            class="btn-spinner"
            aria-hidden="true"
          ></span>

          <svg
            v-else-if="justSaved"
            class="saved-icon"
            viewBox="0 0 20 20"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M5 10.3L8.2 13.5L15 6.7"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <span>
            {{ buttonText }}
          </span>
        </button>

      </div>

    </div>

  </section>
</template>


<script setup>

import {
  ref,
  computed,
  onMounted
} from "vue";

import UserService
  from "../../api/UserService";


const notifications = ref({
  buyer: true,
  review: true
});


const initial = ref("");

const isSaving = ref(false);
const justSaved = ref(false);


/* ============================================================
   STATE
============================================================ */

const isChanged = computed(() =>
  JSON.stringify(
    notifications.value
  ) !== initial.value
);


const buttonText = computed(() => {

  if (isSaving.value) {
    return "Сохраняем…";
  }

  if (justSaved.value) {
    return "Готово";
  }

  return "Сохранить";

});


/* ============================================================
   LOAD
============================================================ */

onMounted(() => {

  try {

    const profile =
      JSON.parse(
        localStorage.getItem(
          "user_profile"
        )
      );


    if (profile) {

      notifications.value.buyer =
        profile.smsMailing
        ?? true;


      notifications.value.review =
        profile.pushMailing
        ?? true;

    }

  } catch (e) {

    console.warn(
      "⚠️ Не удалось загрузить user_profile:",
      e
    );

  }


  initial.value =
    JSON.stringify(
      notifications.value
    );

});


/* ============================================================
   SAVE
============================================================ */

async function save() {

  if (
    !isChanged.value
    || isSaving.value
  ) {
    return;
  }


  isSaving.value = true;
  justSaved.value = false;


  try {

    await UserService.updateNotifications({

      smsMailing:
        notifications.value.buyer,

      pushMailing:
        notifications.value.review

    });


    try {

      const profile =
        JSON.parse(
          localStorage.getItem(
            "user_profile"
          )
          || "{}"
        );


      profile.smsMailing =
        notifications.value.buyer;


      profile.pushMailing =
        notifications.value.review;


      localStorage.setItem(
        "user_profile",
        JSON.stringify(profile)
      );

    } catch {}


    initial.value =
      JSON.stringify(
        notifications.value
      );


    justSaved.value = true;


    setTimeout(
      () => (
        justSaved.value = false
      ),
      1200
    );


  } catch (e) {

    console.error(
      "❌ Ошибка сохранения уведомлений:",
      e
    );

  } finally {

    isSaving.value = false;

  }

}

</script>


<style scoped>

/* ============================================================
   ROOT
============================================================ */

.notifications-page {
  width: 100%;

  display: flex;
  flex-direction: column;

  gap: 16px;

  font-family:
    "Eastman-Regular",
    sans-serif;
}


/* ============================================================
   BASE CARD
============================================================ */

.notifications-card,
.settings-card {
  position: relative;

  width: 100%;

  box-sizing: border-box;

  overflow: hidden;

  background: #ffffff;

  border:
    1px solid
    rgba(
      20,
      35,
      60,
      0.09
    );

  border-radius: 24px;

  box-shadow:
    0 16px 45px
    rgba(
      15,
      23,
      42,
      0.055
    );
}


/* ============================================================
   HEADER
============================================================ */

.notifications-card {
  padding: 28px;
}


.card-header {
  position: relative;

  z-index: 2;

  display: flex;
  align-items: flex-start;

  gap: 15px;
}


.header-icon {
  width: 48px;
  height: 48px;

  flex:
    0
    0
    48px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #3f7fe1;

  background:
    linear-gradient(
      145deg,
      rgba(40, 135, 247, 0.12),
      rgba(124, 92, 231, 0.075)
    );

  border:
    1px solid
    rgba(
      40,
      120,
      230,
      0.11
    );

  border-radius: 15px;
}


.header-icon svg {
  width: 23px;
  height: 23px;
}


.header-copy {
  min-width: 0;
}


.eyebrow,
.section-eyebrow {
  margin-bottom: 5px;

  color: #9499a2;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 9px;

  line-height: 1.2;

  letter-spacing: 0.07em;

  text-transform: uppercase;
}


.card-title {
  margin: 0;

  color: #292e35;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size: 17px;

  line-height: 1.3;

  letter-spacing: -0.25px;
}


.card-description {
  max-width: 560px;

  margin:
    6px
    0
    0;

  color: #80858e;

  font-size: 11px;

  line-height: 1.5;
}


/* ============================================================
   GLOW
============================================================ */

.card-glow {
  position: absolute;

  width: 220px;
  height: 220px;

  pointer-events: none;

  border-radius: 50%;

  filter:
    blur(75px);

  opacity: 0.1;
}


.card-glow-blue {
  top: -120px;
  right: -60px;

  background: #2887f7;
}


.card-glow-purple {
  bottom: -150px;
  left: -90px;

  background: #7c5ce7;
}


/* ============================================================
   SETTINGS CARD
============================================================ */

.settings-card {
  padding:
    26px
    20px
    20px;
}


.section-heading {
  padding:
    0
    8px
    19px;
}


.section-heading h3 {
  margin: 0;

  color: #30353d;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 14px;

  font-weight: 500;
}


.section-heading p {
  margin:
    5px
    0
    0;

  color: #989da5;

  font-size: 9px;

  line-height: 1.4;
}


/* ============================================================
   LIST
============================================================ */

.settings-list {
  display: flex;
  flex-direction: column;
}


.notification-row {
  display: grid;

  grid-template-columns:
    42px
    minmax(0, 1fr)
    51px;

  align-items: center;

  gap: 13px;

  min-height: 84px;

  padding:
    12px
    10px;

  border-radius: 15px;

  transition:
    background-color
    0.2s ease;
}


.notification-row:hover {
  background:
    rgba(
      40,
      135,
      247,
      0.035
    );
}


.notification-icon {
  width: 42px;
  height: 42px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #4d7bd5;

  background:
    #f4f7fb;

  border:
    1px solid
    rgba(
      30,
      45,
      65,
      0.055
    );

  border-radius: 13px;
}


.notification-icon svg {
  width: 19px;
  height: 19px;
}


.push-icon {
  color: #7365d8;

  background:
    rgba(
      116,
      95,
      216,
      0.07
    );
}


/* ============================================================
   COPY
============================================================ */

.notification-copy {
  min-width: 0;
}


.notification-title-row {
  display: flex;
  align-items: center;

  gap: 9px;

  min-width: 0;
}


.notification-title {
  color: #383d45;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 11px;

  line-height: 1.3;
}


.notification-description {
  max-width: 510px;

  margin-top: 5px;

  color: #969ba4;

  font-size: 9px;

  line-height: 1.45;
}


/* ============================================================
   STATUS
============================================================ */

.status-badge {
  display: inline-flex;
  align-items: center;

  gap: 5px;

  min-height: 22px;

  padding:
    0
    8px;

  flex-shrink: 0;

  color: #969ba3;

  background:
    rgba(
      30,
      40,
      55,
      0.045
    );

  border:
    1px solid
    rgba(
      30,
      40,
      55,
      0.06
    );

  border-radius: 999px;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 7px;
}


.status-dot {
  width: 4px;
  height: 4px;

  background: #aaaeb5;

  border-radius: 50%;
}


.status-badge.active {
  color: #278457;

  background:
    rgba(
      52,
      181,
      112,
      0.075
    );

  border-color:
    rgba(
      52,
      181,
      112,
      0.11
    );
}


.status-badge.active
.status-dot {
  background: #39b874;
}


/* ============================================================
   IOS SWITCH
============================================================ */

.ios-switch {
  position: relative;

  width: 51px;
  height: 31px;

  flex:
    0
    0
    51px;

  padding: 0;

  appearance: none;
  -webkit-appearance: none;

  background: #d7d9de;

  border: none;
  border-radius: 999px;

  cursor: pointer;

  transition:
    background-color
    0.25s ease,
    box-shadow
    0.25s ease;
}


.switch-knob {
  position: absolute;

  top: 3px;
  left: 3px;

  width: 25px;
  height: 25px;

  background: #ffffff;

  border-radius: 50%;

  box-shadow:
    0
    2px
    7px
    rgba(
      0,
      0,
      0,
      0.21
    );

  transition:
    transform
    0.28s
    cubic-bezier(
      0.22,
      1,
      0.36,
      1
    );
}


.ios-switch.active {
  background: #34c759;

  box-shadow:
    0
    5px
    14px
    rgba(
      52,
      199,
      89,
      0.19
    );
}


.ios-switch.active
.switch-knob {
  transform:
    translateX(20px);
}


/* ============================================================
   DIVIDER
============================================================ */

.divider {
  height: 1px;

  margin-left: 65px;

  background:
    rgba(
      25,
      40,
      60,
      0.065
    );
}


/* ============================================================
   SAVE
============================================================ */

.save-area {
  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 20px;

  margin-top: 15px;

  padding:
    18px
    8px
    2px;

  border-top:
    1px solid
    rgba(
      25,
      40,
      60,
      0.065
    );
}


.save-state {
  display: inline-flex;
  align-items: center;

  gap: 6px;

  color: #9a9fa7;

  font-size: 8px;
}


.save-state-dot {
  width: 5px;
  height: 5px;

  background: #b9bdc3;

  border-radius: 50%;

  transition:
    background-color
    0.2s ease;
}


.save-state-dot.changed {
  background: #f2a23a;
}


/* ============================================================
   BUTTON
============================================================ */

.primary-btn {
  min-width: 128px;
  min-height: 40px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  gap: 8px;

  padding:
    0
    16px;

  color: #ffffff;

  background:
    linear-gradient(
      135deg,
      #3187ee,
      #4968e6
    );

  border: none;
  border-radius: 12px;

  box-shadow:
    0
    7px
    17px
    rgba(
      40,
      111,
      225,
      0.2
    );

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 10px;

  cursor: pointer;

  transition:
    opacity
    0.2s ease,
    transform
    0.2s ease,
    box-shadow
    0.2s ease,
    background
    0.2s ease;
}


.primary-btn:hover:not(:disabled) {
  transform:
    translateY(-1px);

  box-shadow:
    0
    10px
    22px
    rgba(
      40,
      111,
      225,
      0.27
    );
}


.primary-btn:active:not(:disabled) {
  transform:
    translateY(0)
    scale(0.98);
}


.primary-btn:disabled {
  opacity: 0.42;

  cursor: default;

  box-shadow: none;
}


.primary-btn.saved {
  background:
    linear-gradient(
      135deg,
      #39b875,
      #299761
    );
}


.saved-icon {
  width: 15px;
  height: 15px;
}


.btn-spinner {
  width: 14px;
  height: 14px;

  border:
    2px solid
    rgba(
      255,
      255,
      255,
      0.35
    );

  border-top-color: #ffffff;

  border-radius: 50%;

  animation:
    spin
    0.7s
    linear
    infinite;
}


@keyframes spin {

  to {
    transform:
      rotate(360deg);
  }

}


/* ============================================================
   DARK
============================================================ */

html[data-theme="dark"]
.notifications-card,
html[data-theme="dark"]
.settings-card {
  background:
    linear-gradient(
      145deg,
      #22242a,
      #1d1f24
    );

  border-color:
    rgba(
      255,
      255,
      255,
      0.07
    );

  box-shadow:
    0
    18px
    50px
    rgba(
      0,
      0,
      0,
      0.24
    );
}


html[data-theme="dark"]
.card-title,
html[data-theme="dark"]
.section-heading h3,
html[data-theme="dark"]
.notification-title {
  color: #f0f1f3;
}


html[data-theme="dark"]
.card-description,
html[data-theme="dark"]
.section-heading p,
html[data-theme="dark"]
.notification-description {
  color: #8e939c;
}


html[data-theme="dark"]
.notification-icon {
  background:
    rgba(
      255,
      255,
      255,
      0.045
    );

  border-color:
    rgba(
      255,
      255,
      255,
      0.055
    );
}


html[data-theme="dark"]
.notification-row:hover {
  background:
    rgba(
      255,
      255,
      255,
      0.035
    );
}


html[data-theme="dark"]
.ios-switch {
  background: #4a4d54;
}


html[data-theme="dark"]
.divider,
html[data-theme="dark"]
.save-area {
  border-color:
    rgba(
      255,
      255,
      255,
      0.065
    );
}


html[data-theme="dark"]
.divider {
  background:
    rgba(
      255,
      255,
      255,
      0.065
    );
}


/* ============================================================
   MOBILE
============================================================ */

@media (max-width: 700px) {

  .notifications-page {
    gap: 13px;
  }


  .notifications-card {
    padding: 20px;

    border-radius: 20px;
  }


  .settings-card {
    padding:
      21px
      12px
      14px;

    border-radius: 20px;
  }


  .notification-row {
    grid-template-columns:
      38px
      minmax(0, 1fr)
      51px;

    gap: 10px;

    padding:
      11px
      8px;
  }


  .notification-icon {
    width: 38px;
    height: 38px;
  }


  .status-badge {
    display: none;
  }


  .save-area {
    align-items: stretch;
    flex-direction: column;

    gap: 12px;
  }


  .primary-btn {
    width: 100%;

    min-height: 42px;
  }

}


/* ============================================================
   REDUCED MOTION
============================================================ */

@media (prefers-reduced-motion: reduce) {

  .notification-row,
  .ios-switch,
  .switch-knob,
  .primary-btn {
    transition: none;
  }


  .btn-spinner {
    animation: none;
  }

}

</style>